<template>
   <div class="report-main">
        <div class="report-list"  v-if="!isShowModelFormList">
            <div class="report-item" v-for="(item,index) in reportList" :key="index" @click="showDetail(item.id)">
                <div class="report-item-left">
                    <i :class="item.modelType === 2?'iconfont icon-other-baobiao':'el-icon-s-marketing'"></i>
                </div>
                <div class="report-item-right">
                    {{item.name}}
                </div>
            </div>
        </div>
        <div class="report-detail" v-if="isShowModelFormList">
            <ModelFormList
                ref="formListChild"
                :key="loadTimer"
                :selectedModel="selectedModel"
                :formBtnAuth="formBtnAuth"
                :fullScreen="fullScreen"
                :isNewPage="true"
                :fromReport="true"
                :minuend="minuend"
                :showLeft="false"
                :isReportShowSummary="true"
                @swtitcList="swtitcList"
                @showSearch="showSearch"
                @refreshSearchConditon="refreshSearchConditon"
            />
        </div>
        <!-- 侧滑弹窗 -->
        <el-drawer
          :visible.sync="active"
          title="搜索查询"
          :direction="direction"
          size="20vw"
            >
          <SearchConditionSide
              ref="searchConditon"
              :conditionFields="conditionFields"
              @searchForList="searchForList"
              @resetSearchConditon="resetSearchConditon"
          />
        </el-drawer>
   </div>
</template>

<script>
    import ModelFormList from '@/pages/business/BusinessApplication/ModelFormList';
    import SearchConditionSide from '@/components/SearchCondition/SearchConditionSide';
    import {getApplicationModelMenuList, getApplicationModelDetail, getFormFieldListByIds} from '@/data-model';
    export default {
        components: {
            ModelFormList,
            SearchConditionSide
        },
        data () {
            return {
                reportList: [],
                loadTimer: '',
                selectedModel: {},
                formBtnAuth: {
                    isShowView: true, // 查看
                    isShowAdd: false, // 新增
                    isShowEdit: false, // 修改
                    isShowDelete: true, // 删除
                    isShowImport: true, // 导入
                    isShowExport: true, // 导出
                    isShowSyn: true, // 同步流程数据
                    isShowConfig: false // 进入应用配置
                },
                isShowModelFormList: false,
                fullScreen: true,
                active: false,
                conditionFields: [],
                direction: 'ltr'
            };
        },
        props: {
            appId: {
                type: Number,
                default: 0
            },
            minuend: {
                type: Number,
                default: 180
            }
        },
        created () {
            // this.initReportData();
        },
        methods: {
            async initReportData () {
                let appSystemlList = [];
                let reportList = [];
                if (this.appId === 0) {
                    appSystemlList = await getApplicationModelMenuList();
                } else {
                    appSystemlList = await getApplicationModelMenuList({ appId: this.appId });
                }
                if (appSystemlList && appSystemlList.length > 0) {
                    for (let i = 0; i < appSystemlList.length; i++) {
                        let curObj = appSystemlList[i];
                        let subModel = curObj.subModel;
                        let children = curObj.children;
                        if (subModel && subModel.length > 0) { // 如果存在直属子节点则取出来
                            for (let i = 0; i < subModel.length; i++) {
                                let subModelObj = subModel[i];
                                if (subModelObj.modelType === 2 || subModelObj.modelType === 6) { // 2报表 6聚合表
                                    reportList.push(subModelObj);
                                }
                            }
                        }
                        if (children && children.length > 0) { // 如果子集则继续便利
                            for (let i = 0; i < children.length; i++) {
                                let childrenObj = children[i];
                                let subModel = childrenObj.subModel;
                                if (subModel && subModel.length > 0) { // 如果存在直属子节点则取出来
                                    for (let i = 0; i < subModel[i].length; i++) {
                                        let subModelObj = subModel[i];
                                        if (subModelObj.modelType === 2 || subModelObj.modelType === 6) { // 2报表 6聚合表
                                            reportList.push(subModelObj);
                                        }
                                    }
                                }
                                let childrenList = childrenObj.children;
                                if (childrenList && childrenList.length > 0) {
                                    // console.log(childrenList);
                                    for (let i = 0; i < childrenList.length; i++) {
                                        let obj = childrenList[i];
                                        if (obj.modelType === 2 || obj.modelType === 6) { // 2报表 6聚合表
                                            reportList.push(obj);
                                        }
                                    }
                                }
                            }
                        }
                    }
                    this.reportList = reportList;
                    if (this.reportList.length < 1) {
                        this.$message({
                            message: '暂无数据',
                            type: 'warning',
                            duration: 2000
                        });
                    }
                } else {
                    this.reportList = [];
                    this.$message({
                        message: '没有查询到数据',
                        type: 'warning',
                        duration: 2000
                    });
                }
            },
            async showDetail (id) {
                let modelObj = await getApplicationModelDetail(id);
                this.selectedModel = modelObj;
                setTimeout(() => {
                    // 调用子组件的方法
                    if (this.$refs.formListChild) {
                        this.$refs.formListChild._initFormData();
                    }
                }, 0);
                this.loadTimer = new Date().getTime();
                this.isShowModelFormList = true;
            },
            async refreshSearchConditon (columns) {
                this.conditionFields.length = 0;
                let idArr = [];
                columns.forEach(item => {
                    idArr.push(item.id);
                });
                let cfs = await getFormFieldListByIds(idArr.join(','));
                this.conditionFields = [];
                if (cfs && cfs.length > 0) {
                    for (var i = 0; i < cfs.length; i++) {
                        if (cfs[i].type === 'subform') {
                            continue;
                        } else {
                            this.conditionFields.push(cfs[i]);
                        }
                    }
                }
            },
            swtitcList () {
                this.isShowModelFormList = false;
            },
            searchForList () {
                setTimeout(() => {
                    // 调用子组件的方法
                    if (this.$refs.formListChild) {
                        this.$refs.formListChild.searchForList(this.conditionFields);
                    }
                }, 0);
            },
            resetSearchConditon () {
                this.$refs.formListChild.searchForList([], true);
            },
            showSearch () {
                this.resetSearchConditon();
                this.active = true;
            }
        }
    };
</script>

<style lang="less" scoped="scoped">
.report-main{
    height: 100%;
    width: 100%;
    overflow-y: overlay;
    .report-list{
        display: flex;
        flex-wrap:wrap;
        .report-item{
            height: 80px;
            display: flex;
            width: auto;
            text-align: left;
            line-height: 80px;
            cursor: pointer;
            border: 1px solid #e1e6ec;
            margin-left: 1vw;
            margin-top: 10px;
            border-radius: 6px;
            color: #615858;
            .report-item-left{
                width: 50px;
                height: 80px;
                line-height: 90px;
                text-align: center;
                padding-left: 1vw;
                .icon-other-baobiao,.el-icon-s-marketing{
                    font-size: 2rem;
                }
            }
            .report-item-right{
                font-size: 1.75rem;
                height: 80px;
                line-height: 80px;
                padding-right: 1vw;
            }
        }
        .report-item:hover{
            border: 1px solid #7dcef3;
        }
    }
}
</style>



// WEBPACK FOOTER //
// src/components/ApplicationReport/ApplicationReport.vue